<div aria-label="Crear Local">
    <div style="margin-bottom: 10px;">
      <button type="button" mat-icon-button class="close-button" [mat-dialog-close]="true">
        <mat-icon class="close-icon">close</mat-icon>
      </button>
      <h1 mat-dialog-title >Crear Local</h1> 
    </div>
    <div mat-dialog-content> 
        <form novalidate name="form" #f="ngForm"> 
            <mat-card class="no-pad">
                <mat-card-content>
                    <div class="layout-padding" fxLayout="column" style="margin-top: 20px">
                        <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
                            <mat-label>Nombre</mat-label>
                            <input  type="text" name="name" matInput #name="ngModel" 
                            [(ngModel)]="oc_localCompany.name" maxlength="250" required/>
                            <mat-hint align="end">
                            {{ name.value?.length || 0 }}/30
                            </mat-hint>
                            <mat-error *ngIf="name.errors &&(name.touched || name.dirty)">
                            Este campo es requerido
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
                            <mat-label>País</mat-label>
                            <mat-select
                              name="country"
                              class="max-width"
                              required
                              #country="ngModel"
                              [(ngModel)]="oc_localCompany.countryId"
                              (selectionChange)="fn_handleNewCountrySelection($event.value)"
                            >
                                <mat-option *ngFor="let c of vc_resources?.countries" [value]="c.id">
                                    {{c.name}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="country.errors && (country.touched || country.dirty)">
                              Este campo es requerido
                            </mat-error>
                          </mat-form-field>

                        <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
                            <mat-label>Direccion</mat-label>
                            <input type="text" name="userAddress" matInput #userAddress="ngModel" 
                            [(ngModel)]="oc_localCompany.address" maxlength="250" required/>
                            <mat-hint align="end">
                            {{ userAddress.value?.length || 0 }}/100
                            </mat-hint>
                            <mat-error *ngIf="userAddress.errors &&(userAddress.touched || userAddress.dirty)">
                            Este campo es requerido
                            </mat-error>
                        </mat-form-field>

                        <ng-container *ngIf="vc_resources && vc_resources.locationLevels && vc_resources.locationLevels.length > 0 && vc_resources.locations">
                            <ng-container *ngFor="let level of vc_resources.locationLevels; let i = index">
                              <mat-form-field
                                fxFlex="30"
                                fxFlex.md="30"
                                fxFlex.xs="100"
                              >
                                <mat-label>{{ level.name }}</mat-label>
                                <mat-select
                                  [(ngModel)]="vc_selectedLocations[level.levelOrder]"
                                  [ngModelOptions]="{standalone: true}"
                                  (selectionChange)="fn_handleSelectedLocation($event.value, level.levelOrder + 1)"
                                >
                                  <mat-option
                                  *ngFor="let location of filterLocations(level.levelOrder)"
                                  [value]="location.id"
                                  >
                                    {{ location.name }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </ng-container>
                        </ng-container>

                        <div fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
                            <app-phone-input 
                                [obj_selectedCountryCode]="vc_selectedCountryCode"
                                [obj_initialPhoneNumber]="oc_localCompany.phone ? oc_localCompany.phone : ''"
                                (obj_newPhoneNumber)="fn_updatedPhoneNumber($event)"
                                (obj_newNormalizedPhoneNumber)="fn_updateNormalizedPhoneNumber($event)"
                            >
                            </app-phone-input>
                        </div>


                        <!-- <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
                            <mat-label>Direccion</mat-label>
                            <input  type="text" name="address" matInput #address="ngModel" 
                            [(ngModel)]="oc_localCompany.address" maxlength="250" required/>
                            <mat-hint align="end">
                            {{ address.value?.length || 0 }}/30
                            </mat-hint>
                            <mat-error *ngIf="address.errors &&(address.touched || address.dirty)">
                            Este campo es requerido
                            </mat-error>
                        </mat-form-field>
                        
                        <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
                            <mat-label>Telefono</mat-label>
                            <input  type="text" name="phone" matInput #phone="ngModel" 
                            [(ngModel)]="oc_localCompany.phone" maxlength="250" required/>
                            <mat-hint align="end">
                            {{ phone.value?.length || 0 }}/30
                            </mat-hint>
                            <mat-error *ngIf="phone.errors &&(phone.touched || phone.dirty)">
                            Este campo es requerido
                            </mat-error>
                        </mat-form-field>  -->
                        
                        <!-- <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
                            <mat-label>Departamento</mat-label>
                            <mat-select
                                name="department_id"
                                class="max-width"
                                required
                                #department_id="ngModel"
                                [(ngModel)]="oc_localCompany.department_id"
                                (selectionChange)="fn_updateProvinces()">
                                <mat-option *ngFor="let c of vc_resources.departments" [(value)]="c.id">{{
                                c.name
                                }}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="department_id.errors && (department_id.touched || department_id.dirty)">
                                Este campo es requerido
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
                            <mat-label>Provincia</mat-label>
                            <mat-select
                                name="province_id"
                                class="max-width"
                                required
                                #province_id="ngModel"
                                [(ngModel)]="oc_localCompany.province_id"
                                (selectionChange)="fn_updateDistricts()"
                            >
                                <mat-option *ngFor="let c of vc_resources.provinces" [(value)]="c.id">{{
                                c.name
                                }}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="province_id.errors && (province_id.touched || province_id.dirty)">
                                Este campo es requerido
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
                            <mat-label>Distrito</mat-label>
                            <mat-select
                                name="district_id"
                                class="max-width"
                                required
                                #district_id="ngModel"
                                [(ngModel)]="oc_localCompany.district_id"
                            >
                                <mat-option *ngFor="let c of vc_resources.districts" [(value)]="c.id">{{
                                c.name
                                }}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="district_id.errors && (district_id.touched || district_id.dirty)">
                                Este campo es requerido
                            </mat-error>
                        </mat-form-field> -->

                    </div>
                </mat-card-content>
            </mat-card>
        </form>
    </div>
    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="end"> 
        <button type="button" mat-button (click)="fn_cancel()" >Cerrar</button> 
        <button type="button" mat-button color="primary" (click)="fn_save()" 
        [disabled]="!f.valid" cdkFocusInitial>
            {{vc_textbtnGrabar}}
        </button>
    </div>
    <mat-progress-bar *ngIf="vc_isLoading" mode="indeterminate" class="my-16"></mat-progress-bar>
  </div>
  